import { useContext } from "react";
import { ApplicationContext } from "../../../components/ApplicationProvider";
import {
    ModalContainer,
    AnalyzeBannerModal,
    StyledText,
    CancelIconWrapper,
    InfoIconWrapper,
    IconsContainer,
} from "./AnalyzeLearnMoreModalStyle";
import Parser from "html-react-parser";
import InfoIconImage from "../../../images/info_medium.svg";
import CloseMarkImage from "../../../images/close_mark.svg";
import { Icon } from "grabcad-ui-elements";
import { streamLineProURL } from "../../../utils/constants";

export interface IAnalyzeLearnMoreModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onCancel: () => void;
}

export const AnalyzeLearnMoreModal = (props: IAnalyzeLearnMoreModalProps) => {
    const { open, setOpen, onCancel } = props;
    const { t } = useContext(ApplicationContext);

    const handleClose = () => {
        setOpen(false);
        onCancel();
    };

    return (
        <AnalyzeBannerModal
            onClose={handleClose}
            open={open}
            size="small"
            data-testid="analyze-banner-modal"
        >
            <IconsContainer>
                <InfoIconWrapper>
                    <Icon data-testid="info-icon">
                        <img src={InfoIconImage} alt="close" />
                    </Icon>
                </InfoIconWrapper>
                <CancelIconWrapper onClick={handleClose} data-testid="close-icon">
                    <Icon>
                        <img src={CloseMarkImage} alt="close" />
                    </Icon>
                </CancelIconWrapper>
            </IconsContainer>
            <ModalContainer>
                <StyledText data-testid="analyze-banner-modal-text">
                    {Parser(
                        t("homepage.analyze_banner_modal.instruction", {
                            stream_line_pro_url: streamLineProURL,
                        })
                    )}
                </StyledText>
            </ModalContainer>
        </AnalyzeBannerModal>
    );
};
